import type { FC } from 'react';
import { Spinner } from '@george-labs.com/design-system';

import { t } from '@luna/i18n';

type Props = {
    'data-cy'?: string;
};

/**
 * A spinner component to be used in the Lazy Routers
 * @constructor
 */
export const PageSpinner: FC<Props> = ({ 'data-cy': dataCy }) => (
    <Spinner
        data-cy={dataCy}
        size={Spinner.SIZE.LARGE}
        center
        className="m-5"
        screenreaderText={t('app.loading')}
    />
);
